module.exports = __webpack_public_path__ + "static/media/colib-logo.4c7ac8a6.svg";